// extracted by mini-css-extract-plugin
export default {"modalWithForm":"page_modalWithForm__D37SP","description":"page_description__TfZ+g","action":"page_action__bklbb"};